import tw, { styled, css } from 'twin.macro';
import twConfig, { theme } from '../../tailwind.config';

export default styled.div.attrs(({ $show }) => ({
  $visible: $show ?? true
}))(({ $visible, $size }) => [
  !$visible && tw`hidden`,
  tw`absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2 m-0 text-center text-lg z-1000`,
  css`
    width: 2.25rem;
    height: 2.25rem;
  `,
  css`
    &:before {
      ${tw`absolute top-0 left-0 w-full h-full border-solid border-silver-lighten-20`}
      content: '';
      border-radius: 500rem;
      border-width: 0.2rem;
    }
  `,
  css`
    &:after {
      ${tw`absolute top-0 left-0 w-full h-full border-solid`}
      content: '';
      border-radius: 500rem;
      border-width: 0.2em;
      border-color: ${theme.colors.blue.base} transparent transparent;
      ${tw`animate-spin`}
    }
  `,
  $size === 'small' &&
    css`
      width: 1.75rem;
      height: 1.75rem;
    `
]);
